//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/// For the buttons to occupy the whole space of the screen
// when using the full-width mode, they should be
/// enclosed in a div with class='row'

export default {
    name: "AQButton",
    props: {
        label: { type: String, default: undefined },
        condensed: { type: Boolean, default: false },
        round: { type: Boolean, default: false },
        color: { type: String, default: "" },
        disabled: { type: Boolean, default: false },
        icon: { type: String, default: undefined },
        iconRight: { type: String, default: undefined },
        fullWidth: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
        hasNormalState: { type: Boolean, default: false }, // prop used for disable state, to look normal, but disabled
        wide: { type: Boolean, default: false }, // used for the wide button from design, aka the long one with no border and icon on the right side
        flat: { type: Boolean, default: false }
    },
    computed: {
        aqButtonClass() {
            const result = [];
            if (this.condensed) {
                result.push("condensed");
            } else {
                result.push("normal");
            }
            if (!this.label) {
                result.push("aqicononly");
            }
            if (this.hasNormalState) {
                result.push("normal-disable");
            }
            if (this.iconRight && this.label) {
                result.push("has-ricon");
            }
            if (this.icon && this.label) {
                result.push("has-licon");
            }
            if (this.fullWidth) {
                result.push("col, full-width");
            }
            if (this.wide) {
                result.push("wide-btn");
            }
            switch (this.color) {
                case "primary":
                    result.push("aqprimary");
                    break;
                case "secondary":
                    result.push("aqsecondary");
                    break;
                case "outline":
                    result.push("aqoutline");
                    break;
                case "link":
                    result.push("aqlink");
                    break;
                case "error":
                    result.push("aqerror");
                    break;
                case "orange":
                    result.push("aqorange");
                    break;
                case "secondary-error":
                    result.push("aqsecondaryerror");
                    break;
                default:
            }
            return result;
        },
        textColor() {
            let textColor = "";
            switch (this.color) {
                case "primary":
                case "secondary":
                case "error":
                    textColor = "white";
                    break;
                case "outline":
                    textColor = "primary-text-color";
                    break;
                case "link":
                    textColor = "primary";
                    break;
                case "secondary-error":
                    textColor = "white";
                    break;
                default:
                    textColor = "primary";
            }
            return textColor;
        }
    },
    created() {
        // colors.setBrand("primary", "#4285F4");
        // colors.setBrand("secondary", "#00CC66");
    },
    methods: {
        click(event) {
            this.$emit("click", event);
        }
    }
};
